import { Learning_Series_Subscription_Settings_Discount_Type_Enum } from '../graphql/learning/api-types'

export type SubscriptionDiscountTypeEnum =
  Learning_Series_Subscription_Settings_Discount_Type_Enum
export const SubscriptionDiscountType =
  Learning_Series_Subscription_Settings_Discount_Type_Enum
